<template>
  <b-card no-body :id="'widgetppt' + widget.id">
    <div class="card-header" :class="{fixedCardHeader: isOverflown}">
      <span v-b-tooltip.hover :title="title" class="widget-title">{{title}}</span>
      <settings-button />
    </div>
    <b-card-body class="p-3 clearfix" v-show="loaded === true" @click="handleClickThrough">
      <doughnut-chart class="doughnut-chart" style="max-width: 800px; max-height: 400px; margin: 0 auto; position: relative; height: 100%; width: 100%;" ref=chart v-if="!compareDates || widget.disableDataComparison"/>
      <div class="row" v-if="compareDates && !widget.disableDataComparison">
        <div class="col-sm-6 chart-container">
          {{startDate}} - {{endDate}}
          <doughnut-chart style="max-width: 400px; max-height: 400px; margin: 0 auto; position: relative; height: 100%; width: 100%; min-height: 150px;" ref=chart />
        </div>
        <div class="col-sm-6 chart-container">
          {{compareStartDate}} - {{compareEndDate}}
          <doughnut-chart style="max-width: 400px; max-height: 400px;margin: 0 auto; position: relative; height: 100%; width: 100%; min-height: 150px;" ref=compareChart />
        </div>
      </div>
    </b-card-body>
    <b-card-body v-show="loaded === false" class="p-3 clearfix">
      <h5 class="loading-text">{{ loadMessage }}</h5>
    </b-card-body>
    <div class="comparison-disclaimer" v-if="this.widget.disableDataComparison"><sup>*</sup>Data comparison unavailable</div>
  </b-card>
</template>

<script>
import DoughnutChart from '@/views/charts/DoughnutChart'
import { base_widget } from '@/views/widgets/base_widget'
import { mapGetters } from 'vuex'

export default {
  mixins: [base_widget],
  components: {
    DoughnutChart
  },

  data () {
    return {
      compareDates: false,
      loadMessage: 'Loading...',
      loaded: false
    }
  },

  created () {
    this.$eventBus.$on('compareDatesEnabled', (e) => {this.compareDates = e})
  },

  methods: {
    setData (response) {
      var chart = this.$refs.chart
      var disableLegend = this.widget.disableLegend
      var useDoughnutPercentages = this.widget.use_doughnut_percentages
      if (this.customData) {
        this.loaded = false
        this.setChartData(response, chart, disableLegend)
        return false
      }
      if (this.widget.widget_titles && this.widget.widget_titles.length > 0){
        response.data.data.labels = response.data.data.labels.map(function(label, index){
          if (this.widget.widget_titles[index]){
            return this.widget.widget_titles[index]
          } else {
            return label
          }
        }.bind(this))
      }
      if (response.data.data.value) {
        this.compareDates = true
        this.$nextTick(() => {
          var chart = this.$refs.chart // ref changes after compareDates updates
          this.setChartData(response.data.data.value, chart, disableLegend, useDoughnutPercentages)
          var compareChart = this.$refs.compareChart
          this.setChartData(response.data.data.compare_value, compareChart, disableLegend, useDoughnutPercentages)
        })
      } else {
        this.compareDates = false
        this.setChartData(response.data.data, chart, disableLegend, useDoughnutPercentages)
      }
    },

    setChartData (data, chart, disableLegend=false, useDoughnutPercentages=false) {
      let datasets, labels
      if (this.customData) {
        datasets = [{
          data: data
        }]
        labels = this.customData.map((widget) => {
          return widget.label
        })
      } else {
        if (this.widget.options && this.widget.options.records_amount) {
          labels = data.labels.slice(0, this.widget.options.records_amount)
          data.datasets[0].data = data.datasets[0].data.slice(0, this.widget.options.records_amount)
          datasets = data.datasets
        } else {
          datasets = data.datasets
          labels = data.labels
        }
      }
      if (labels.length === 1 && labels[0] === null) {
        this.loadMessage = 'No data Available'
        this.saveWidgetData({}, [])
      } else {
        this.loaded = true
      }
      chart.datasets = datasets
      chart.labels = labels
      chart.disableLegend = disableLegend
      chart.useDoughnutPercentages = useDoughnutPercentages
      chart.createChart()
      this.saveWidgetData(datasets.map( (set) => set.data), labels)
    }
  },

  computed: {
     ...mapGetters(['startDate', 'compareStartDate', 'endDate', 'compareEndDate'])
  }

}
</script>

<style scoped>
  .loading-text {
    color: #757575;
    text-align: center;
    margin-top: 10px;
    text-transform: uppercase;
    font-family: 'Cooper Hewitt Semibold';
    letter-spacing: 3px;
  }
  .chart-container {
    text-align: center;
  }
</style>

<style>
  .doughnut-chart {
    min-height: 300px;
  }
</style>
